import React from 'react';
import Reveal from '../fx/Reveal';

const partners = [
    { name: 'Tentara Nasional Indonesia (TNI)', logo: '/partners/tni.png' },
    { name: 'Kepolisian Negara Republik Indonesia (POLRI)', logo: '/partners/polri.png' },
    { name: 'Direktorat Jenderal Pajak — Kementerian Keuangan RI', logo: '/partners/djp.png' },
    { name: 'Satsiber TNI', logo: '/partners/satsiber.png' },
    { name: 'Kemendikdasmen RI', logo: '/partners/kemendikdasmen.png' },
    { name: 'Perum Peruri', logo: '/partners/peruri.png' },
    { name: 'FamilyMart', logo: '/partners/familymart.png' },
    { name: 'Tetra Data Teknologi', logo: '/partners/tetradata.png' },
    { name: 'SMKN 22 Jakarta', logo: '/partners/smkn22.png' },
    { name: 'RekaProteksi.id', logo: '/partners/rekaproteksi.png' },
    { name: 'Orang Siber Indonesia', logo: '/partners/orangsiber.png' },
    // { name: 'REDAC7D', logo: '/partners/redac7d.png', dark: true },
];

const Partners = () => {
    return (
        <section className="relative bg-[#08090f] text-white px-6 md:px-16 py-24 overflow-hidden">
            <Reveal className="relative max-w-7xl mx-auto text-center mb-14">
                <span className="pill tag inline-flex mb-4">TRUSTED BY</span>
                <h2 className="font-display text-4xl md:text-5xl font-bold">
                    Trusted across <span className="text-gradient-red">Indonesia</span>
                </h2>
                <p className="text-gray-400 max-w-2xl mx-auto mt-3 text-lg">
                    Organizations across government, military, education, and industry trust SiberLab
                    for training, cyber exercises, and security assessments.
                </p>
            </Reveal>

            {/* Infinite logo carousel — pauses on hover */}
            <Reveal className="marquee-mask marquee-pause">
                <div className="marquee-track items-stretch py-2" style={{ '--marquee-speed': '32s' }}>
                    {[...partners, ...partners].map((p, i) => (
                        <div
                            key={i}
                            title={p.name}
                            className={`mx-3 flex items-center justify-center rounded-2xl p-6 w-52 md:w-60 h-28 md:h-32 shrink-0 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-12px_rgba(255,0,0,0.4)] ${
                                p.dark
                                    ? 'bg-[#16161c] border border-white/10 hover:border-red-500/40'
                                    : 'bg-white hover:bg-white'
                            }`}
                        >
                            <img
                                src={p.logo}
                                alt={p.name}
                                className="max-h-16 md:max-h-20 max-w-full object-contain"
                            />
                        </div>
                    ))}
                </div>
            </Reveal>
        </section>
    );
};

export default Partners;
